import styled from 'styled-components';

export const ObsHighLowDetails = styled.div`
    display: flex;
    flex-direction: row;
    height: 100%;
    width: 49%;
    font-size: 16px;
    font-weight: 400;
    color: #ffffff;
`;
